import React, { Component } from "react";

export default class ResourceListLoadingCaption extends Component {
  render() {
    return (
      <div className="slide-caption">
        <header>
          <p className="resource-title" />
        </header>
        <div className="resource-description">
          <p />
        </div>
        <div className="resource-utility" />
      </div>
    );
  }
}
